import { render, staticRenderFns } from "./PaymentsBarChart.vue?vue&type=template&id=e3924440&"
import script from "./PaymentsBarChart.vue?vue&type=script&lang=js&"
export * from "./PaymentsBarChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports